import { DropDownWithLabelModel } from "./dropDown";

export enum OwnershipTypeId {
    none = "",
    other = "OTHER",
    renter = "RENTER",
    propertyForRent = "PROPERTY_FOR_RENT",
    cooperativeProprietorship = "COOPERATIVE_PROPRIETORSHIP",
    ownership = "OWNERSHIP"
}

export const OwnershipTypes: DropDownWithLabelModel = {
    label: "Forma własności",
    dropDown: [
        {
            id: OwnershipTypeId.none,
            displayName: ""
        },
        {
            id: OwnershipTypeId.ownership,
            displayName: "Własność"
        },
        {
            id: OwnershipTypeId.cooperativeProprietorship,
            displayName: "Spółdzielcze"
        },
        {
            id: OwnershipTypeId.propertyForRent,
            displayName: "Własność na wynajem"
        },
        {
            id: OwnershipTypeId.renter,
            displayName: "Najemca"
        },
        {
            id: OwnershipTypeId.other,
            displayName: "Inne"
        }
    ]
};
